module.exports = __webpack_public_path__ + "static/img/program_ttl.dd9ff08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/program_ttl.svg
// module id = SgPF
// module chunks = 0